var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('tr',[_c('td',{attrs:{"colspan":_vm.cols}},[_vm._v(" Loading Data... ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }